import { render } from "./register.vue?vue&type=template&id=4b4f3521&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=4b4f3521&scoped=true&lang=css"

import exportComponent from "E:\\newyear\\chatgpt\\chat-bot-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4f3521"]])

export default __exports__